import {
  Lock as LockManagerIcon,
  Menu as MenuIcon,
  Home as HomeIcon,
  People as PeopleIcon,
  Category as CategoryIcon,
  Business as BusinessIcon,
  Person as PersonIcon,
  Description as DescriptionIcon,
  Security as SecurityIcon,
  Settings as SettingsIcon,
  DocumentScanner as DocumentScannerIcon,
  ExpandLess,
  ExpandMore,
  Flag as FlagIcon,
  TrendingUp as TrendingUpIcon,
} from '@mui/icons-material';


import BadgeIcon from '@mui/icons-material/Badge';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { JSX } from 'react';


export type MenuItem = {
  text: string;
  icon: JSX.Element;
  path: string;
  entidade: string | null;
};
export const MenuItems = [
  {
    text: 'Início',
    icon: <HomeIcon />,
    path: '/',
    entidade: null, // sempre visível
  },
  {
    text: 'Clientes',
    icon: <PersonIcon />,
    path: '/clientes',
    entidade: 'clientes',
  },
  {
    text: 'Prospecção',
    icon: <CalendarMonthIcon />,
    path: '/visitas-prospeccao',
    entidade: 'prospeccao',
  },
  {
    text: 'Apólices',
    icon: <DescriptionIcon />,
    path: '/apolices',
    entidade: 'apolice',
  },
  {
    text: 'Lançamentos',
    icon: <MonetizationOnIcon />,
    path: '/financeiro',
    entidade: 'financeiro',
  },
  {
    text: 'Metas',
    icon: <FlagIcon />,
    path: '/metas',
    entidade: 'metas',
  },
  {
    text: 'Relatórios',
    icon: <DocumentScannerIcon />,
    path: '/relatorios',
    entidade: 'relatorios',
  },
  {
    text: 'Credenciais',
    icon: <LockManagerIcon />,
    path: '/credenciais',
    entidade: 'credenciais',
  },
];
